import messages from './cmsUpload.json' with { type: 'json' };

export const cmsUploadFi: Readonly<typeof messages> = messages;
